import Link from "next/link";
import clsx from "clsx";
import styles from "./index.module.scss";
import Breadcrumbs from "../../common/breadcrumbs";
import ResizedImage from "../../common/resizedImage";
import News from "../../baltex/news";
import { NEWS_PAGE_SIZE } from "../../../pagesSrrLogic/news";
import { formatDate } from "../../../utils";
import PagenOld from "../../common/pagenOld";

export default function Articles({
  code = false,
  hideDate = false,
  isBaltex,
  isFarkop,
  isLanding,
  title,
  sections,
  section,
  newsItems = [],
  imageReset = false,
  size,
  currentPage,
}) {
  const list = Array.isArray(newsItems) ? newsItems : [];
  return (
    <div className="container">
      <Breadcrumbs />
      <h1 className={clsx(isBaltex && styles.h1Baltex)}>{title}</h1>
      <div>
        {isFarkop && section.CODE !== "akczii" && (
          <ul className={styles.Sections}>
            {sections
              .filter((section) => section.CODE !== "akczii")
              .map((section) => (
                <li
                  key={section.ID}
                  className={clsx(code === section.CODE && styles.Selected)}
                >
                  <Link href={`/${section.CODE}`}>{section.NAME}</Link>
                </li>
              ))}
          </ul>
        )}
        {(isFarkop || isLanding) && (
          <div className={styles.NewsList}>
            {list.map((item) => (
              <Link href={`/${code}/${item.CODE}/`} key={item.CODE}>
                <a data-test="contentListItem">
                  {!isLanding && (
                    <div className={styles.Picture}>
                      <ResizedImage
                        imageId={item.PICTURE_ID}
                        src={item.PICTURE}
                        width={300}
                        height={200}
                        fit="cover"
                        reset={imageReset}
                        alt={item.NAME}
                        title={item.NAME}
                      />
                    </div>
                  )}
                  <div className={styles.Info}>
                    <div className={styles.Name}>{item.NAME}</div>
                    <span className={styles.Bottom}>
                      {!hideDate &&
                        `${item.FORMATTED_DATE ?? formatDate(item.DATE)} · `}
                      {section?.NAME}
                    </span>
                  </div>
                </a>
              </Link>
            ))}
          </div>
        )}
        {isBaltex && <News items={list} isShowTitle={false} />}
        <div className={styles.Pagen}>
          <PagenOld
            count={size}
            size={NEWS_PAGE_SIZE}
            currentNum={currentPage}
            pagen="page"
          />
        </div>
      </div>
    </div>
  );
}
